<template>
  <div class="footer">
    <div class="footer-menu">
      <div class="item" @click="openAboutLink">关于我们</div>
      <div class="item" @click="openConnectionLink">联系我们</div>
      <div class="item" @click="gotoWebsiteMessagePage">留言反馈</div>
    </div>
    <div class="email">企业邮箱zmpx1912@126.com</div>
    <div class="copyrightNumber">
      中国煤炭工业协会培训中心 版权所有<span @click="openNumberLink" class="number"
        >京ICP备17015936号-1</span
      >
      <span @click="openNumberLink2" class="number">京公网安备11010502042070号</span>
    </div>
    <img src="@/assets/images/jncyLayout/crz2002.png" class="footer-icon" @click="openLink" />
  </div>
</template>
<script lang="ts" setup>
import { siteURL, jncyURL } from '@/configs/Constant';

const openLink = () => {
  window.open(`https://www.etrust.org.cn/CX885276404735.html`);
};

const openAboutLink = () => {
  window.open(`${siteURL}c/2019-11-11/4.shtml`);
};

const openConnectionLink = () => {
  window.open(`${siteURL}c/2019-11-11/2.shtml`);
};

const openNumberLink = () => {
  window.open(`https://beian.miit.gov.cn/`);
};

const openNumberLink2 = () => {
  window.open(`https://beian.mps.gov.cn/#/query/webSearch?code=11010502042070`);
};

const gotoWebsiteMessagePage = () => {
  window.open(`${jncyURL}/websiteMessage.html`);
};
</script>
<style lang="scss" scoped>
.footer {
  // zoom: var(--zoom);
  width: 100%;
  height: 2.5rem;
  min-height: 160px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: #f6f6f6;
  &-menu {
    display: flex;
    align-items: center;
    .item {
      position: relative;
      font-size: 0.18rem;
      color: #242424;
      cursor: pointer;
      &:hover {
        color: #ea3b31;
      }
    }

    .item + .item {
      $item-left: 0.8rem;
      margin-left: $item-left;
      &::before {
        top: 0;
        left: -$item-left / 2;
        content: '';
        position: absolute;
        height: 0.21rem;
        width: 0.02rem;
        background: #242424;
      }
    }
  }
  .email,
  .copyrightNumber {
    margin-top: 0.2rem;
    font-size: 0.18rem;
    color: #242424;
  }
  .footer-icon {
    margin-top: 0.2rem;
    width: 1.48rem;
    height: 0.54rem;
  }
  .number {
    cursor: pointer;
    &:hover {
      color: #ea3b31;
    }
  }
}
</style>
<style scoped lang="scss">
@media (max-width: 768px) {
  .footer {
    padding-top: 10px;
    .footer-menu {
      .item {
        font-size: 16px;
      }
    }
    .email {
      font-size: 16px;
    }
    .copyrightNumber {
      font-size: 12px;
    }
  }
}
</style>
